export default {
  state: () => ({
    timer: null,
    timestamp: null,
    interval: 2000,
    delta: 50,
    lag: false
  }),

  actions: {
    setActivityTimer({ commit, dispatch, state }) {
      // Reset timer
      window.clearInterval(state.timer);
      commit('setActivityTimestamp', null);
      commit('setActivityTimerLag', false);

      // Add new timer
      const timer = window.setInterval(() => {
        const now = Date.now();
        if (state.timestamp) {
          if (
            now >= state.timestamp + state.interval - state.delta &&
            now <= state.timestamp + state.interval + state.delta
          ) {
            console.log('true');
            commit('setActivityTimestamp', now);
            commit('setActivityTimerLag', false);
          } else {
            if (!state.lag) {
              console.log('THIS IS A LAG!');
              commit('setActivityTimerLag', true);
              commit('setActivityTimestamp', now);
              dispatch('disableConnectionWithSocket');
              dispatch('setConnectionWithSocket');
            }
          }
        } else {
          commit('setActivityTimestamp', now);
        }
      }, state.interval);
      commit('setActivityTimer', timer);
    }
  },

  mutations: {
    setActivityTimestamp(state, timestamp) {
      state.timestamp = timestamp;
    },

    setActivityTimer(state, timer) {
      state.timer = timer;
    },

    setActivityTimerLag(state, status) {
      state.lag = status;
    }
  }
};
